var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('vertical-form-table', _vm._b({
    on: {
      "input": _vm.emit
    },
    scopedSlots: _vm._u([{
      key: "급여",
      fn: function () {
        return [_c('v-row', {
          staticClass: "row--small"
        }, [_c('v-col', {
          attrs: {
            "cols": "12",
            "lg": "5"
          }
        }, [_c('v-select', {
          staticClass: "form-employment-wage-type",
          attrs: {
            "items": _vm.wageTypes,
            "menuProps": {
              attach: '.form-employment-wage-type'
            },
            "attach": "",
            "outlined": ""
          },
          on: {
            "change": _vm.onChangeWageType
          },
          model: {
            value: _vm.form.employment.wage.type,
            callback: function ($$v) {
              _vm.$set(_vm.form.employment.wage, "type", $$v);
            },
            expression: "form.employment.wage.type"
          }
        })], 1), _c('v-col', {
          attrs: {
            "cols": "12",
            "lg": "7"
          }
        }, [_c('v-row', {
          staticClass: "row--small",
          attrs: {
            "align": "center"
          }
        }, [_c('v-col', {
          attrs: {
            "cols": "12",
            "md": ""
          }
        }, [_c('v-currency-field', {
          staticClass: "text-right",
          attrs: {
            "label": `최소금액`,
            "outlined": "",
            "suffix": "원"
          },
          on: {
            "input": _vm.emit
          },
          model: {
            value: _vm.form.employment.wage.value__min,
            callback: function ($$v) {
              _vm.$set(_vm.form.employment.wage, "value__min", $$v);
            },
            expression: "form.employment.wage.value__min"
          }
        })], 1), _c('v-col', {
          attrs: {
            "cols": "auto"
          }
        }, [_vm._v(" ~ ")]), _c('v-col', [_c('v-currency-field', {
          staticClass: "text-right",
          attrs: {
            "label": `최대금액`,
            "outlined": "",
            "suffix": "원"
          },
          on: {
            "input": _vm.emit
          },
          model: {
            value: _vm.form.employment.wage.value__max,
            callback: function ($$v) {
              _vm.$set(_vm.form.employment.wage, "value__max", $$v);
            },
            expression: "form.employment.wage.value__max"
          }
        })], 1)], 1)], 1), _c('v-expand-transition', [_c('v-col', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: !_vm.isWageDisabled,
            expression: "!isWageDisabled"
          }],
          attrs: {
            "cols": "12"
          }
        }, [_c('v-btn', {
          staticClass: "mx-n12",
          attrs: {
            "small": "",
            "text": "",
            "color": "primary",
            "href": "http://www.minimumwage.go.kr/index.jsp",
            "target": "_blank"
          }
        }, [_c('v-layout', {
          attrs: {
            "justify-start": "",
            "align-center": ""
          }
        }, [_c('span', [_vm._v(" 최저임금제도 바로가기 ")]), _c('i', {
          staticClass: "icon icon-right-arrow-sm ml-4 ml-lg-8"
        }), _c('v-chip-group', {
          staticClass: "ml-10"
        }, [_c('v-chip', {
          staticClass: "grey--text",
          attrs: {
            "color": "grey-f8"
          }
        }, [_vm._v(" 시급 9,629원 ")]), _c('v-chip', {
          staticClass: "grey--text",
          attrs: {
            "color": "grey-f8"
          }
        }, [_vm._v(" 일급 76.960원 ")]), _c('v-chip', {
          staticClass: "grey--text",
          attrs: {
            "color": "grey-f8"
          }
        }, [_vm._v(" 월급 2,010,580원 ")])], 1)], 1)], 1)], 1)], 1)], 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }, 'vertical-form-table', {
    items: _vm.items
  }, false));

}
var staticRenderFns = []

export { render, staticRenderFns }